import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import symmetry_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/symmetry.svg';
import { img } from '@phi/components';
import { uid_make_edges_symmetric_with_spinner } from '@frontend/ui_display';
import SymmetryTooltip from './SymmetryTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const SymmetryIcon = symmetry_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Add to symmetry sets';
        },

        disabled() {
            return !this.state.loaded
                || !this.edge_or_face_selected
                || !this.state.symmetry_plane_selected;
        },

        edge_or_face_selected() {
            return this.state.selected_edges_count > 0
                || this.state.selected_faces_count > 0;
        }
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                uid_make_edges_symmetric_with_spinner(true, false);
        }
    },

    render() {
        return h(BarButton, {
            onClick: this.onClick,
            disabled: this.disabled,
            id: 'symmetry-button',
            tippy: 'left',
            active: false,
            selected: this.state.tut_stage === 9,
            help: 'make_symmetric',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(symmetry_svg, this.alt),
            tooltip: SymmetryTooltip,
        });
    }
});
